import { ReactNode, createContext } from "react";
import useGerenteFotografo, { CreateGerenteFotografoResponse, CreateGerenteFotografoType, GerenteFotografoType, UpdateGerenteFotografoType } from "./hooks/useGerenteFotografo";
import { TerceiroType } from "./hooks/useTerceiro";

interface GerenteFotografoContextProviderProps {
    children: ReactNode;
}

export interface GerenteFotografoContextData {
    getAllGerenteFotografoPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<GerenteFotografoType[] | null>;
    setGerenteFotografo: any;
    gerenteFotografo: GerenteFotografoType;
    setListGerenteFotografo: any;
    listGerenteFotografo: GerenteFotografoType[];
    setInitialListGerenteFotografo: any;
    initialListGerenteFotografo: GerenteFotografoType[];
    setGerenteFotografoPageCount: any;
    gerenteFotografoPageCount: number;
    createGerenteFotografo: (createGerenteFotografoType: CreateGerenteFotografoType) => Promise<CreateGerenteFotografoResponse | null>;
    updateGerenteFotografo: (updateGerenteFotografoType: UpdateGerenteFotografoType) => Promise<UpdateGerenteFotografoType | null>;
    deleteGerenteFotografo: (id: number) => Promise<GerenteFotografoType | null>;
    handleGetGerenteFotografoByEmpresaId: (empresaId: number) => Promise<GerenteFotografoType[] | null>;
    listGerenteFotografoByEmpresa: GerenteFotografoType[];
    setListGerenteFotografoByEmpresa: any;
    handleGetFotografosByGerente: (gerenteId: number) => Promise<TerceiroType[] | null>;
}

const initialState: GerenteFotografoContextData = {
    getAllGerenteFotografoPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setGerenteFotografo: () => { },
    gerenteFotografo: {
        id: 0,
        gerenteId: 0,
        gerenteName: "",
        fotografoId: 0,
        fotografoName: ""
    },
    setListGerenteFotografo: () => { },
    listGerenteFotografo: [],
    setInitialListGerenteFotografo: () => { },
    initialListGerenteFotografo: [],
    setGerenteFotografoPageCount: () => { },
    gerenteFotografoPageCount: 0,
    createGerenteFotografo: async (createGerenteFotografoType: CreateGerenteFotografoType) => {
        return Promise.resolve(null);
    },
    updateGerenteFotografo: async (updateGerenteFotografoType: UpdateGerenteFotografoType) => {
        return Promise.resolve(null);
    },
    deleteGerenteFotografo: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetGerenteFotografoByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listGerenteFotografoByEmpresa: [],
    setListGerenteFotografoByEmpresa: () => { },
    handleGetFotografosByGerente: async (gerenteId: number) => {
        return Promise.resolve([]);
    }
};

export const GerenteFotografoContext =
    createContext<GerenteFotografoContextData>(initialState);

export default function GerenteFotografoContextProvider({
    children,
}: GerenteFotografoContextProviderProps) {
    const {
        getAllGerenteFotografoPaged,
        createGerenteFotografo,
        updateGerenteFotografo,
        deleteGerenteFotografo,
        gerenteFotografo,
        setGerenteFotografo,
        setListGerenteFotografo,
        listGerenteFotografo,
        initialListGerenteFotografo,
        setInitialListGerenteFotografo,
        setGerenteFotografoPageCount,
        gerenteFotografoPageCount,
        handleGetGerenteFotografoByEmpresaId,
        listGerenteFotografoByEmpresa,
        setListGerenteFotografoByEmpresa,
        handleGetFotografosByGerente,
    } = useGerenteFotografo();

    return (
        <GerenteFotografoContext.Provider
            value={{
                getAllGerenteFotografoPaged,
                createGerenteFotografo,
                updateGerenteFotografo,
                deleteGerenteFotografo,
                gerenteFotografo,
                setGerenteFotografo,
                setListGerenteFotografo,
                listGerenteFotografo,
                initialListGerenteFotografo,
                setInitialListGerenteFotografo,
                setGerenteFotografoPageCount,
                gerenteFotografoPageCount,
                handleGetGerenteFotografoByEmpresaId,
                listGerenteFotografoByEmpresa,
                setListGerenteFotografoByEmpresa,
                handleGetFotografosByGerente,
            }}
        >
            {children}
        </GerenteFotografoContext.Provider>
    );
}